import React, {Component} from 'react';
import { API_BASE_URL } from '../../apiConfig';

class Dev extends Component {

    devapi = () => {
        
        const url = `${API_BASE_URL}/api/development`;

        fetch(url, {
            method: 'GET',
            credentials: 'include',
            mode : 'cors',
        })
        .then(response => response.json())
        .then(result => {
            console.log(result)
        })
    }

    render() {
        // TODO: Add dev tools
        return(
            <section className="dev">
            </section>
        )
    }
}

export default Dev;